import { Component,Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PharmacyService } from '../../../services/pharmacyservice';
import { ToastrService } from 'ngx-toastr';
import { PharmacyStoreModel } from '../../DTO/pharmacy-store-crud';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-pharmacy-store',
  templateUrl: './pharmacy-store.component.html',
  styleUrls: ['./pharmacy-store.component.css']
})
export class PharmacyStoreComponent {
  form: FormGroup;
  NCPDPID: FormControl;
  isLoading: boolean = false;
  userName: string='';
  NCPDPIDDuplicateErrorMsg: string='';
  pharmacyStoreModel= new PharmacyStoreModel();
  constructor(private pharmacyService: PharmacyService, private toastr:ToastrService,
    @Inject(MAT_DIALOG_DATA) public pharmacyModel: any, public dialog: MatDialog) {
     
  }

  ngOnInit() {
    this.createFormControls();
    this.createForm();
    this.userName = localStorage.getItem("loggedName");
    //this.NCPDPID.setValue(this.pharmacyModel.NCPDPID);
  }
  createFormControls() {
    this.NCPDPID = new FormControl('', [Validators.required]);
  }

  createForm() {
    this.form = new FormGroup({
      NCPDPID: this.NCPDPID,
    });
  }

  get errorMessageForPharmacyNcpdpid(): string {
    const pharmacyform: FormControl = (this.form.get('NCPDPID') as FormControl);
    return pharmacyform.hasError('required') ?
      'Pharmacy NCPDP ID is required' :
      pharmacyform.hasError('invalid_ncpdpid') ?
      'Please enter only numeric values' :
      pharmacyform.hasError('invalid_ncpdpid_length') ?
      'Length of Pharmacy NCPDP ID should be 7 characters' :
      pharmacyform.hasError('duplicate') ?
      this.NCPDPIDDuplicateErrorMsg : "" 
  }

  clearDuplicateValidation(){
    this.NCPDPID.setErrors({'duplicate': null});
    this.NCPDPID.updateValueAndValidity();
    this.NCPDPID.setErrors({'invalid_ncpdpid': null});
    this.NCPDPID.updateValueAndValidity();
  }

  submitForm(){
    if (this.form.valid) {
      this.isLoading = true;
      this.pharmacyStoreModel.PharmacyId=this.pharmacyModel.PharmacyId;
      this.pharmacyStoreModel.UpdatedBy=this.userName;
      let pharmacyNCPDPIDs = this.form.get('NCPDPID')?.value;
      //remove empty string from string array
      this.pharmacyStoreModel.NCPDPIDs = pharmacyNCPDPIDs.split("\n").filter((item:any)=>item);
      let arr=this.pharmacyStoreModel.NCPDPIDs;
      const findDuplicateVal = (arr:any) => arr.filter((item:any, index:any) => arr.indexOf(item) != index);
      let duplicateNCPDPIDs=findDuplicateVal(arr);
      let distinctDuplicateNCPDPIDs = Array.from(new Set(duplicateNCPDPIDs));
      if(distinctDuplicateNCPDPIDs.length>0){
        this.NCPDPIDDuplicateErrorMsg = 'Pharmacy NCPDP ID exist ('+distinctDuplicateNCPDPIDs.join(', ')+'). No records added.';
        this.NCPDPID.setErrors({'duplicate': true});
        this.form.get('NCPDPID')?.markAsTouched();
        this.isLoading = false;
        return;
      }
      this.pharmacyService.savePharmacyStores(this.pharmacyStoreModel).subscribe(res => {
        this.isLoading = false;
        if(res.ResponseStatus==true){
          this.dialog.closeAll();
          this.toastr.success('Pharmacy store saved successfully');
        }
        else if(res.ResponseMessage=='InvalidPharmacyNCPDPID'){
          this.NCPDPID.setErrors({'invalid_ncpdpid': true});
          this.form.get('NCPDPID')?.markAsTouched();
        }
        else if(res.ResponseMessage=='InvalidPharmacyNCPDPIDLength'){
          this.NCPDPID.setErrors({'invalid_ncpdpid_length': true});
          this.form.get('NCPDPID')?.markAsTouched();
        }
        else if(res.ResponseStatus==false && res.ResponseMessage!=''){
          this.toastr.error(res.ResponseMessage);
        }
      },(error: any)=>{
        this.isLoading=false;
        if(error.indexOf('Duplicate Pharmacy NCPDP ID')>-1){
          this.NCPDPIDDuplicateErrorMsg = error+' No records added.';
          this.NCPDPID.setErrors({'duplicate': true});
          this.form.get('NCPDPID')?.markAsTouched();
        }
        else{
          this.toastr.error(error);
        }
      });
    }
  }
}

